const Icon = ({ className }: { className?: string }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" className={`icon icon-moon ${className}`}>
    <path
      className="moon main-outline"
      xmlns="http://www.w3.org/2000/svg"
      d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"
    />
  </svg>
);

export default Icon;
